import styled from 'styled-components';
import { Link } from 'gatsby';

import { navbarHeight } from '../../../components/Layout/constants';
import Container from '../Container';

export const HeroArea = styled.section`
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: ${navbarHeight + 32}px 32px 64px;
  margin-top: -${navbarHeight}px;
  background: linear-gradient(135deg, #1b1857 0%, #2d2a75 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeroContainer = styled(Container)`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const HeroContent = styled.div`
  text-align: center;
  width: 100%;
`;

export const HeroTitle = styled.h1`
  margin: 0 0 24px;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
  
  @media (min-width: 768px) {
    font-size: 3rem;
  }
  
  @media (min-width: 1024px) {
    font-size: 3.5rem;
    margin-bottom: 32px;
  }
`;

export const HeroDescription = styled.p`
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  margin: 0 auto 32px;
  max-width: 600px;
  line-height: 1.6;

  @media (min-width: 768px) {
    font-size: 1.25rem;
    margin-bottom: 40px;
  }
`;

export const SearchContainer = styled.div`
  max-width: 600px;
  margin: 0 auto 48px;

  @media (min-width: 768px) {
    margin-bottom: 64px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 80px;
  }

  /* Style the SearchArea wrapper */
  > div {
    width: 100%;
  }

  /* Style the SearchButton from Search component */
  button {
    width: 100%;
    height: 56px;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    color: white;
    font-size: 16px;
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
    justify-content: center;
    padding: 0 24px;
    margin: 0;

    &:hover,
    &:focus {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.3);
    }

    svg {
      width: 20px;
      height: 20px;

      path {
        fill: white;
      }
    }

    span {
      color: rgba(255, 255, 255, 0.9);
      font-size: 16px;
      margin-left: 12px;
    }

    kbd {
      background: rgba(255, 255, 255, 0.2);
      border-color: rgba(255, 255, 255, 0.3);
      color: rgba(255, 255, 255, 0.9);
    }
  }
`;

export const NavigationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  max-width: 900px;
  margin: 0 auto;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
  }
`;

export const NavTile = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  min-height: 160px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  text-decoration: none;
  color: white;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    color: white;
  }

  @media (min-width: 768px) {
    padding: 32px 20px;
    min-height: 180px;
  }
`;

export const NavTileIcon = styled.div`
  font-size: 32px;
  margin-bottom: 12px;
  
  @media (min-width: 768px) {
    font-size: 36px;
    margin-bottom: 16px;
  }
  
  &.platform {
    color: #4A90E2;
  }
  
  &.poqstudio {
    color: #9B59B6;
  }
  
  &.developers {
    color: #2ECC71;
  }
  
  &.ecosystem {
    color: #E67E22;
  }
  
  &.marketing {
    color: #E74C3C;
  }
  
  &.help {
    color: #3498DB;
  }
`;

export const NavTileTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const NavTileDescription = styled.p`
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  line-height: 1.4;
  
  @media (min-width: 768px) {
    font-size: 13px;
  }
`;


